/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourUpdateThumbnailURLInput = {
    id: string;
    thumbnailURL: unknown;
};
export type TourNewThumbnailMutationVariables = {
    input: TourUpdateThumbnailURLInput;
};
export type TourNewThumbnailMutationResponse = {
    readonly tourUpdateThumbnailURL: {
        readonly tour: {
            readonly id: string;
            readonly thumbnailURL: string;
        };
    };
};
export type TourNewThumbnailMutation = {
    readonly response: TourNewThumbnailMutationResponse;
    readonly variables: TourNewThumbnailMutationVariables;
};



/*
mutation TourNewThumbnailMutation(
  $input: TourUpdateThumbnailURLInput!
) {
  tourUpdateThumbnailURL(input: $input) {
    tour {
      id
      thumbnailURL
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TourUpdateThumbnailURLPayload",
    "kind": "LinkedField",
    "name": "tourUpdateThumbnailURL",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Tour",
        "kind": "LinkedField",
        "name": "tour",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnailURL",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourNewThumbnailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourNewThumbnailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2f8fa8aafd1dd87df931758bcfc181f7",
    "id": null,
    "metadata": {},
    "name": "TourNewThumbnailMutation",
    "operationKind": "mutation",
    "text": "mutation TourNewThumbnailMutation(\n  $input: TourUpdateThumbnailURLInput!\n) {\n  tourUpdateThumbnailURL(input: $input) {\n    tour {\n      id\n      thumbnailURL\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0888ed43cdaa2b16b8fe5282ea080642';
export default node;
